module.exports = __webpack_public_path__ + "assets/da1a36e634bfcf384ca782193d5dcd73.png";